<template>
<div>
  <Header/>
    <div class="container">
      <div class="row">
        <div class="my-2">
            <img src="../assets/roombox-login.png" alt="" >
          </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-4">
          <div style="margin-top:60px">
             <h6 class="text-dark title-panel my-2 mx-5">
              ACCESO AL PANEL DE ADMINISTRACIÓN
            </h6>
            <form v-on:submit.prevent="login" class="mx-5" >
            <div class="my-4 text-center col-12">
              <label for="exampleInputEmail1" class="form-label">Usuario *</label>
              <input type="email" class="form-control input text-center" id="exampleInputEmail1" v-model="usuario">
            </div>
            <div class="ym-54text-center col-12">
              <label for="exampleInputPassword" class="form-label">Contraseña *</label>
              <input type="password" class="form-control input text-center" id="exampleInputPassword"  v-model="password" required>
            </div>
            <div class="alert alert-danger my-3" role="alert" v-if="error">
              {{error_msg}}
            </div>
            <button type="submit" class="btn btn-danger navbar-button submit my-5 px-5 ">Entrar</button>
        </form>
          </div>
        </div>
      </div>
</div>
</div>
</template>

<script>
import axios from 'axios';
import Header from "../components/Header"
export default {
  name: 'Home',
  components:{
    Header,
  },
  data(){
    return {
      usuario:"",
      password:"",
      error:false,
      error_msg:"",
      userAdmin:""
    }
  },
  methods:{
    login(){
      let json={
        "usuario": this.usuario,
        "password": this.password
      };
      axios.post('https://eciadmin.roombox3d.com/auth.php',json)
      .then(data =>{
        if(data.data.statusMsg.status){
            localStorage.token=data.data.token;
            this.$router.push('/dashboard/');

        }
        else{
          this.error=true;
          this.error_msg=data.data.statusMsg.message;
          }
      });

      }
  }
}
</script>

<style>

@font-face {
  font-family: ECIFont-Medium;
  src: url(../assets/ECIFont/ECIFont-Medium.ttf);
}
@font-face {
  font-family: ECIFont-Regular;
  src: url(../assets/ECIFont/ECIFont-regular.ttf);
}
@font-face {
  font-family: ECIFont-Light;
  src: url(../assets/ECIFont/Ecifont-light.ttf);
}
body::before{
  background-image: url(../assets/background.jpg); 
  background-color: white;
  background-size: center  cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: .1;
  background-attachment: fixed;
  background-position: center center;
}
.modal-padding-body{
  padding: 50px 150px !important;
}
.btn-danger.submit , .btn-danger.guardar {
  color: #fff;
  background-color:#FD8204;
  border-color: #FD8204;
  border-radius: 24px;
  font: 14px ECIFont-Medium;
}
.btn-danger.submit:hover, .btn-danger.guardar:hover, .btn-danger.guardar:active, .btn-danger.guardar:focus, .btn-danger.submit:active, .btn-danger.submit:focus {
  color: #fff;
  background-color: #FA6B00;
  border-color: #FA6B00;
  border-radius: 24px;
  font: 14px ECIFont-Medium;
}
.form-control.input{
  border-radius: 24px;
  font-family: Arial, Helvetica, sans-serif;
}
.email.col-6.input{
  flex: 0 0 auto;
  width: 50%;
}

 .container
 {
     width: 80%;
     margin: 50px auto;
 }
 .row
 {
     position: relative;
     width: 100%;
     box-sizing: border-box;

 }
 .title-panel{
   color: var(--unnamed-color-3e3e3e);
text-align: center;
font: normal normal medium 14px/23px ECIFont;
letter-spacing: 2.1px;
color: #3E3E3E;
opacity: 1;
 }

 .form-label{
   font: 13px ECIFont-Medium;
 }
 .btn-secondary.config:hover, .btn-secondary.config:active, .btn-secondary.config:focus {
  color: #686767;
  background-color: #fff;
  border-color:  #686767;
  border-radius: 24px;
  font: 14px ECIFont-Medium;
}
.btn-secondary.config {
  color: #3E3E3E;
  background-color: #fff;
  border-color: #3E3E3E;
  border-radius: 24px;
  font: 14px ECIFont-Medium;
}

.navbar-button{
  height: 38px;
}
.user-column{
  min-width: 400px !important;
}
a.logout:link {color:#E94746;}
a.logout:visited {color:#E94746;}
a.logout:active {color:#E94746;}
a.logout:hover {color:#E94746 !important;}

.btn-danger.trash:hover, .btn-danger.trash:active, .btn-danger.trash:focus {
  color: #ee2626;
  background-color: #fff;
  border-color:  #ee2626;
  border-radius: 24px;
}
.btn-danger.trash {
  color: #E94746;
  background-color: #fff;
  border-color: #E94746;
  border-radius: 24px;
}
.table.tabla{
    border: none;
    font: 15px ECIFont-Light;
    
}
.table td, .table th {
    border-top: none;
    border-color: #cecccc;
}
.btn.btn-add-user, .btn.btn-search{
    color: #008C2E;
    background-color:#FFFFFF;
    border-color: #008C2E;
    border-radius: 24px;
    font: 15px ECIFont-Light;
}
.btn.btn-add-user:hover, .btn.btn-search:hover{
    color: #FFFFFF;
    background-color:#008C2E;
    border-color: #008C2E;
    border-radius: 24px;
    font: 15px ECIFont-Light;
}
.form-control.input{
    border-radius: 24px;
}
.input{
    width: 100%;
    padding: .375rem .75rem;
    font: 15px ECIFont-light;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 24px;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.select-center{
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 24px;
    font: 15px ECIFont-Light;
}
.form-check-input.active:checked {
    background-color:#008C2E;
    border-color: #008C2E;
}
.page-link.pagination{
    color:#3E3E3E
}
.page-link.pagination:hover {
    color:#3E3E3E
}
.scrollable-menu {
    height: auto;
    max-height: 400px;
    overflow-x: hidden;
}
.label-modal{
  font: 15px ECIFont-Medium;
}
.form-check-label{
  font: 15px ECIFont-Regular;
}
.dropdown-menu{
    font: 15px ECIFont-Light;

}
@media(max-width:1404px){
      .content {  
          width: 100px;
      }
  }
@media(min-width:1404px){
      .content {  
          width: 150px;
      }
  }
  .content {
      text-align: center;
  }

</style>
